<template>
  <div id="view-two">
    <div class="header-gradient" :style="$bgd(data.img)">
      <div class="text">
        <div class="text-container">
          <h3>{{ data.name }}</h3>
          <h1 v-text="data.title" />
          <h2>{{ data.subtitle }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Block from "./Block"

export default {
  name: "ViewTwo",
  components: { Block },
  props: ["data"],
  data() {
    return {}
  },
  methods: {
    bgd(url) {
      return `background-image: url('${url}');`
    },
  },
}
</script>

<style scoped lang="scss">
@import "../style.scss";

#view-two {
  .content {
    padding: 0 5% 20px 5%;
  }
}
</style>
